/** Normalize pasted SMS / Web OTP text to up to 6 digits. */
export const extractOtpCode = (text) => {
  const raw = String(text || '').trim();
  if (/^\d{6}$/.test(raw)) return raw;
  const hashMatch = raw.match(/#\s*(\d{6})\b/);
  if (hashMatch) return hashMatch[1];
  const digits = raw.replace(/\D/g, '');
  if (digits.length >= 6) return digits.slice(0, 6);
  return digits;
};

/** Split OTP into six slots for legacy callers. */
export const splitOtpDigits = (code) => {
  const digits = extractOtpCode(code).split('');
  while (digits.length < 6) digits.push('');
  return digits;
};

/**
 * Chrome/Android Web OTP API.
 * For best results, add to Firebase SMS template (Auth → Templates):
 *   @app.mytownly.in #%LOGIN_CODE%
 */
export const listenForWebOtp = (onCode, signal) => {
  if (typeof window === 'undefined' || !window.OTPCredential) return () => {};

  const handle = (cred) => {
    if (!cred?.code) return;
    const code = extractOtpCode(cred.code);
    if (code.length === 6) onCode(code);
  };

  navigator.credentials
    .get({ otp: { transport: ['sms'] }, signal })
    .then(handle)
    .catch(() => {});

  return () => {};
};

/** Re-request Web OTP when user returns to the tab (SMS may arrive late). */
export const listenForWebOtpWithRetry = (onCode, signal) => {
  const stop = listenForWebOtp(onCode, signal);

  const onVis = () => {
    if (document.visibilityState !== 'visible' || signal?.aborted) return;
    listenForWebOtp(onCode, signal);
  };
  document.addEventListener('visibilitychange', onVis);

  return () => {
    stop();
    document.removeEventListener('visibilitychange', onVis);
  };
};
